import { useCreateExternalStorage } from "../../../../hooks/useExternalStorage";
import { UseFormReturn } from "react-hook-form";
import { StorageType } from "../../../../types/external-storage/StorageType";
import { AWSKeysRequest, awsKeysSchema } from "../../../../api/externalStorage";
import StorageForm from "../update-credentials/StorageForm";
import { FormField } from "../FormField";

interface ConfigureAWSKeysStorageFormProps {
  storageType: StorageType;
  id: string;
  siteId: string;
  setIsOpen: (isOpen: boolean) => void;
}
export default function ConfigureAWSKeysStorageForm({
  storageType,
  id,
  siteId,
  setIsOpen,
}: ConfigureAWSKeysStorageFormProps) {
  const mutationHook = useCreateExternalStorage;

  interface AWSKeysformFieldsProps {
    formState: UseFormReturn<AWSKeysRequest>["formState"];
    register: UseFormReturn<AWSKeysRequest>["register"];
  }

  const handleAwsData = (data: AWSKeysRequest) => data;

  const FormFields = ({ register, formState }: AWSKeysformFieldsProps) => {
    return (
      <>
        <FormField
          label="Bucket Name"
          name="AWSAccessKeys.AWSBucketName"
          register={register}
          formState={formState}
          required
        />
        <FormField
          label="Bucket Prefix"
          name="AWSAccessKeys.AWSBucketPrefix"
          register={register}
          formState={formState}
        />
        <FormField
          label="Region"
          name="AWSAccessKeys.Region"
          register={register}
          formState={formState}
          required
        />
        <FormField
          label="Access Key"
          name="AWSAccessKeys.AccessKey"
          register={register}
          formState={formState}
          required
        />
        <FormField
          label="Secret Key"
          name="AWSAccessKeys.SecretKey"
          register={register}
          formState={formState}
          type="password"
          required
        />
      </>
    );
  };

  return (
    <div>
      <StorageForm
        id={id}
        siteId={siteId}
        schema={awsKeysSchema}
        requestProcessor={handleAwsData}
        mutationHook={mutationHook}
        setIsOpen={setIsOpen}
        options={{
          defaultValues: {
            SiteId: siteId,
            StorageType: storageType as StorageType.ExternalAmazonS3,
            AWSAccessKeys: {
              AWSBucketName: "",
              AccessKey: "",
              SecretKey: "",
              Region: "",
            },
          },
        }}
      >
        {(form) => {
          const { register, formState } = form;
          return <FormFields register={register} formState={formState} />;
        }}
      </StorageForm>
    </div>
  );
}
